import { useState } from "react";
import AceEditor from "react-ace";

import { beautify } from "ace-builds/src-noconflict/ext-beautify";
import "ace-builds/src-noconflict/mode-markdown";
import "ace-builds/src-noconflict/theme-tomorrow_night_eighties";
import "ace-builds/src-noconflict/theme-xcode";
import { PostDescription } from "../post/post-card.component";
import { Checkbox } from "./checkbox.component";

export default function MDEditor({
  text = "Hi, guys!",
  setText = (e) => {},
  getMentionsFeed = async (e) => {
    return [];
  },
  placeholder = "Write something...",
  dark = true,
}) {
  const [isPreviewShown, setIsPreviewShown] = useState(false);

  return (
    <div>
      <div className="mb-3">
        <Checkbox
          selected={isPreviewShown}
          onClick={(e) => {
            setIsPreviewShown(!isPreviewShown);
          }}>
          Show Preview for Markdown
        </Checkbox>
      </div>
      {isPreviewShown ? (
        <div className="PostCard border theme-border-default rounded theme-bg-surface px-4">
          <PostDescription
            post={{
              description: text,
            }}
            showFullPost
          />
        </div>
      ) : (
        <AceEditor
          mode="markdown"
          className="w-full p-2 focus:outline-none ace-dillinger "
          theme={dark ? "tomorrow_night_eighties" : "xcode"}
          onChange={setText}
          name="aceeditor"
          value={text}
          wrapEnabled
          // placeholder={placeholder}
          editorProps={{
            $blockScrolling: true,
          }}
          onPaste={(e) => {
            console.log(e);
          }}
          showGutter={false}
          style={{ border: "1px solid var(--theme-border-color)" }}
          commands={[
            {
              name: "beautify",
              exec: (editor) => {
                beautify(editor.session);
              },
              bindKey: "Shift-Alt-F",
            },
          ]}
        />
      )}
    </div>
  );
}
